
import VerifyComponent from "../components/VerifyComponent";

import useVerify from "../hook/useVerify";

const VerifyPage = ({

}) => {
    const verify = useVerify();
    return <VerifyComponent {...verify} />
}
export default VerifyPage;